export function htmlDecode(input) {
	// var doc = new DOMParser().parseFromString(input, 'text/html')
	// return doc.documentElement.textContent

	const txt = document.createElement('textarea')
	txt.innerHTML = input
	return txt.value
}

export default htmlDecode